var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMascaraEncerrado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 572.739,
    height: 91.846,
    viewBox: "0 0 572.739 91.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.003,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09d785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098caf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0H562.739c5.523,0,10,3.188,10,7.12V84.726c0,3.932-4.477,7.12-10,7.12H10c-5.523,0-10-3.188-10-7.12V7.12C0,3.188,4.477,0,10,0Z",
    transform: "translate(1041.844 4440)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,612.716-.368l-.087,139.313-612.716.368Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1041.844 -4440)",
    opacity: 0.7,
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1017.049 4400.515) rotate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,619.531,3.755l.14,22.387L.14,22.387Z",
    transform: "matrix(0.981, -0.196, 0.196, 0.981, -0.073, 117.384)",
    fill: "#9b0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.427,10.494,9.7,9.667l.5,2.43L2.668,13.556,0,.63,3.26,0Z",
    transform: "translate(219.703 78.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.766,13.206A6.688,6.688,0,0,1,.148,8.087,6.465,6.465,0,0,1,2.383,1.66,7.263,7.263,0,0,1,5.67.143,7.372,7.372,0,0,1,9.307.319,6.584,6.584,0,0,1,12.273,2.2a6.688,6.688,0,0,1,1.609,3.229,6.569,6.569,0,0,1-.211,3.593,6.4,6.4,0,0,1-1.992,2.847A7.168,7.168,0,0,1,8.4,13.382a7.361,7.361,0,0,1-3.637-.176m5.4-4.224a3.871,3.871,0,0,0,.4-2.911A3.954,3.954,0,0,0,9.036,3.523,3.46,3.46,0,0,0,6.26,3,3.417,3.417,0,0,0,3.884,4.51a3.867,3.867,0,0,0-.4,2.931A3.955,3.955,0,0,0,5.015,9.989a3.482,3.482,0,0,0,2.8.521,3.358,3.358,0,0,0,2.352-1.528",
    transform: "translate(229.425 76.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.356-.006l.52,2.522L7.33,3.2l2.147,10.4-3.262.632L4.068,3.835.52,4.521,0,2Z",
    transform: "translate(243.07 72.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78,3.474l.54,2.615,4.369-.845.5,2.43L4.822,8.52l.585,2.838,4.941-.957.522,2.522-8.2,1.587L0,1.584,8.2,0l.52,2.523Z",
    transform: "translate(255.068 70.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78,3.474l.54,2.615,4.368-.846.5,2.43L4.822,8.52l.585,2.838,4.941-.957.521,2.522-8.2,1.587L0,1.584,8.2,0l.521,2.522Z",
    transform: "translate(269.431 68.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.645,12.919l-3.262.633-7.1-6.918,1.645,7.973-3.261.632L0,2.312,3.259,1.68l7.108,6.954L8.715.624l3.262-.632Z",
    transform: "translate(279.751 65.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.314,4.466a6.046,6.046,0,0,1,1.912-2.8A7.209,7.209,0,0,1,5.534.154,7.009,7.009,0,0,1,9.866.579a6.05,6.05,0,0,1,2.955,2.874l-3.586.7a2.939,2.939,0,0,0-1.39-1.014,3.373,3.373,0,0,0-1.757-.1A3.182,3.182,0,0,0,3.856,4.519a3.875,3.875,0,0,0-.375,2.888A3.965,3.965,0,0,0,4.974,9.933a3.263,3.263,0,0,0,2.651.54,3.294,3.294,0,0,0,1.581-.747,2.833,2.833,0,0,0,.88-1.453l3.586-.694a5.814,5.814,0,0,1-1.588,3.744,6.907,6.907,0,0,1-3.833,2A7.335,7.335,0,0,1,4.6,13.155,6.282,6.282,0,0,1,1.723,11.29,6.919,6.919,0,0,1,.161,8.049,6.863,6.863,0,0,1,.314,4.466",
    transform: "translate(294.709 63.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78,3.474l.54,2.615,4.368-.846.5,2.43-4.367.845.585,2.838,4.941-.956.522,2.522-8.2,1.587L0,1.583,8.2,0l.521,2.523Z",
    transform: "translate(308.629 60.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12.811,5.7,8.47l-.782.152L5.928,13.5l-3.261.632L0,1.206,5.472.146a6.346,6.346,0,0,1,2.81.012A3.893,3.893,0,0,1,10.253,1.3a4.11,4.11,0,0,1,.982,1.964,3.8,3.8,0,0,1-.279,2.448A4.07,4.07,0,0,1,9.029,7.576L13.177,12.1ZM4.461,6.393,6.483,6A1.9,1.9,0,0,0,7.74,5.318a1.578,1.578,0,0,0,.2-1.283,1.572,1.572,0,0,0-.688-1.073A1.945,1.945,0,0,0,5.822,2.8L3.8,3.19Z",
    transform: "translate(318.948 58.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12.811,5.7,8.47l-.782.152L5.928,13.5l-3.261.632L0,1.206,5.472.146a6.361,6.361,0,0,1,2.81.012A3.894,3.894,0,0,1,10.253,1.3a4.1,4.1,0,0,1,.982,1.963,3.8,3.8,0,0,1-.279,2.448A4.067,4.067,0,0,1,9.029,7.577L13.177,12.1ZM4.461,6.394,6.483,6A1.9,1.9,0,0,0,7.74,5.318a1.581,1.581,0,0,0,.2-1.284,1.572,1.572,0,0,0-.688-1.073A1.95,1.95,0,0,0,5.822,2.8L3.8,3.189Z",
    transform: "translate(331.384 56.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.733,10.525l-5,.968-.33,2.439-3.414.661L2.169.727,5.945,0l7.512,11.99-3.452.668ZM7.392,8.257,4.756,3.846,4.092,8.9Z",
    transform: "translate(345.619 53.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.883.274a6.13,6.13,0,0,1,2.92,1.8,6.706,6.706,0,0,1,1.565,3.211A6.6,6.6,0,0,1,13.2,8.822a5.893,5.893,0,0,1-1.989,2.761,8.1,8.1,0,0,1-3.524,1.524l-5.017.971L0,1.151,5.016.179A8.213,8.213,0,0,1,8.883.274M9.59,8.888a3.661,3.661,0,0,0,.459-2.962,3.809,3.809,0,0,0-1.6-2.581A4.1,4.1,0,0,0,5.36,2.908l-1.545.3,1.551,7.513,1.545-.3A4.047,4.047,0,0,0,9.59,8.888",
    transform: "translate(357.878 51.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.765,13.206A6.681,6.681,0,0,1,.149,8.087,6.46,6.46,0,0,1,2.382,1.66,7.264,7.264,0,0,1,5.669.143,7.372,7.372,0,0,1,9.306.32,6.583,6.583,0,0,1,12.273,2.2a6.7,6.7,0,0,1,1.609,3.23,6.569,6.569,0,0,1-.211,3.593,6.4,6.4,0,0,1-1.991,2.846A7.168,7.168,0,0,1,8.4,13.383a7.361,7.361,0,0,1-3.637-.177m5.4-4.223a3.883,3.883,0,0,0,.4-2.912A3.958,3.958,0,0,0,9.036,3.523,3.463,3.463,0,0,0,6.259,3,3.422,3.422,0,0,0,3.883,4.51a3.864,3.864,0,0,0-.4,2.931A3.951,3.951,0,0,0,5.014,9.988a3.478,3.478,0,0,0,2.8.522,3.365,3.365,0,0,0,2.353-1.528",
    transform: "translate(372.37 48.398)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascaraEncerrado);
export default __webpack_public_path__ + "static/media/mascara-encerrado.f85c0480a8c9a4dd88581b8a6ae903c2.svg";
export { ForwardRef as ReactComponent };